import { useMutation } from '@tanstack/react-query';

import { HttpClient } from '@/network/HttpClient';

export const useChangeLocaleMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; locale: string }) =>
      HttpClient.request({
        method: 'POST',
        url: params.url,
        data: {
          locale: params.locale,
        },
      }),
  });
